module.exports = __webpack_public_path__ + "img/dnp_visiosign_logo_rgb_somev.d982e59c.svg";